import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cardTitle"
}

import Card from '@intec/vue-components/form/Card.vue';
import DateTimePicker from '@intec/vue-components/form/DateTimePicker.vue';
import Config from '@/config';

interface Props {
  procedure: Object,
  errors: Object,
  onlyDates: Boolean,
  appendToBody: Boolean,
  disabledDate: Function,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcedureStages',
  props: {
    procedure: {},
    errors: {},
    onlyDates: { default: false },
    appendToBody: { default: true },
    disabledDate: { type: Function, default: () => false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
const lang = Config.getUser().getLang();

props.procedure.applicationDeadline = props.procedure.applicationDeadline
    ? new Date(props.procedure.applicationDeadline)
    : null;
props.procedure.summingStart = props.procedure.summingStart
    ? new Date(props.procedure.summingStart)
    : null;

const clearDateErrors = () => {
  props.errors.applicationDeadline = null;
  props.errors.summingStart = null;
};

const validateRequired = (newValue, fieldName) => {
  let hasErrors = false;
  if (newValue === '' || newValue === null) {
    props.errors[fieldName] = 'Это поле обязательно для заполнения';
    hasErrors = true;
  }
  return hasErrors;
};

const applicationDeadlineChanged = (newValue) => {
  clearDateErrors();

  if (validateRequired(newValue, 'applicationDeadline')) return;

  const now = new Date();
  if (newValue < now) {
    props.errors.applicationDeadline = 'Приём заявок не может быть раньше текущей даты';
    return;
  }
  if (props.procedure.summingStart && newValue > props.procedure.summingStart) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше даты приема заявок'
  }
};

const summingStartChanged = (newValue) => {
  clearDateErrors();

  if (validateRequired(newValue, 'summingStart')) return;

  const now = new Date();
  if (newValue < now) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше текущей даты';
    return;
  }

  if (props.procedure.applicationDeadline && props.procedure.applicationDeadline > newValue) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше даты приема заявок';
  }
}

const validate = async () => {
  clearDateErrors();

  const now = new Date();
  let valid = true;

  // Проверка на обязательность.
  if (validateRequired(props.procedure.applicationDeadline, 'applicationDeadline')) {
    valid = false;
  }
  if (validateRequired(props.procedure.summingStart, 'summingStart')) {
    valid = false;
  }

  // Проверка на дату в прошлом.
  if (props.procedure.applicationDeadline && props.procedure.applicationDeadline < now) {
    props.errors.applicationDeadline = 'Приём заявок не может быть раньше текущей даты';
    valid = false;
  }

  if (props.procedure.summingStart && props.procedure.summingStart < now) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше текущей даты';
    valid = false;
  }

  // Логические зависимости.
  if (props.procedure.applicationDeadline
      && props.procedure.summingStart
      && props.procedure.applicationDeadline > props.procedure.summingStart
  ) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше даты приема заявок';
    valid = false;
  }

  return valid;
};

__expose({
  validate
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, { class: "mb-3" }, {
    default: _withCtx(() => [
      (!_ctx.onlyDates)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('Стадии процедуры')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createVNode(DateTimePicker, {
        required: "",
        label: "Приём заявок до",
        modelValue: _ctx.procedure.applicationDeadline,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.procedure.applicationDeadline) = $event)),
          applicationDeadlineChanged
        ],
        error: _ctx.errors['applicationDeadline'],
        "disabled-date": _ctx.disabledDate,
        deafaultNow: false,
        appendToBody: _ctx.appendToBody,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors['applicationDeadline'] = null)),
        lang: _unref(lang)
      }, null, 8 /* PROPS */, ["modelValue", "error", "disabled-date", "appendToBody", "lang"]),
      _createVNode(DateTimePicker, {
        required: "",
        label: "Подведение итогов",
        modelValue: _ctx.procedure.summingStart,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.procedure.summingStart) = $event)),
          summingStartChanged
        ],
        error: _ctx.errors['summingStart'],
        deafaultNow: false,
        "disabled-date": _ctx.disabledDate,
        appendToBody: _ctx.appendToBody,
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errors['summingStart'] = null)),
        lang: _unref(lang)
      }, null, 8 /* PROPS */, ["modelValue", "error", "disabled-date", "appendToBody", "lang"])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})